<template>
  <!--新增/修改表单渲染-->
  <el-dialog append-to-body :close-on-click-modal="false" :visible.sync="dialogVisible" title="社保政策" width="90%"
    @close="handleClose">
    <el-form ref="form" :model="form" size="small" inline>
      <div style="margin-bottom: 15px;">
        <el-form-item label="参保地：" prop="cityCodes" label-width="120px">
          <div style="width: 240px;">{{ form.cityName }}</div>
        </el-form-item>
        <el-form-item label="地区政策名称：" prop="areaPolicy" label-width="120px">
          <div style="width: 240px;">{{ form.areaPolicy }}</div>
        </el-form-item>
        <el-form-item label="保留小数位：" prop="decimalPlace" label-width="120px">
          <div style="width: 240px;">{{ dict.label.DECIMAL_PLACE[form.decimalPlace] }}</div>
        </el-form-item>
      </div>

      <el-divider content-position="left">政策</el-divider>
      <div class="policy-section">
        <el-form-item label="发布时间：" label-width="80" style="margin-bottom: 0; margin-right: 10px;" v-if="form.status == 'PUBLISHED' || type == 'publishedDetail'">
          <div style="width: 250px;">{{ form.publishTime }}</div>
        </el-form-item>
        <el-form-item label="发布时间：" label-width="80" style="margin-bottom: 0; margin-right: 10px;" v-else>
          <div style="width: 250px;color: red;">待发布</div>
        </el-form-item>
        <div v-if="form.policySourceLinks && form.policySourceLinks.length > 0">
          <el-form-item label="政策溯源链接：" label-width="80" style="margin-bottom: 0; margin-right: 10px;">
            <div v-for="(policySource, index) in form.policySourceLinks" :key="index" class="policy-link-item">
              <div v-if="policySource.title">
                <el-link type="primary" :underline="true" :href="policySource.url" target="_blank">
                  {{ index + 1 }}. {{ policySource.title }}
                </el-link>
              </div>
            </div>
          </el-form-item>
        </div>
        <div style="display:flex;align-items: center;background-color: #f4f4f8;padding: 20px">
          如发现政策未更新，请联系平台运营人员。
        </div>
      </div>

      <el-divider content-position="left">保险</el-divider>

        <div class="welfare-list-item">
          <el-table :data="form.welfareList" border :cell-class-name="cellClassName" show-summary :summary-method="getSummaries">
            <el-table-column label="险种" prop="welfareType" min-width="100px" align="center">
              <template v-slot="{ row }">
                {{ dict.label.WELFARE_TYPE[row.welfareType] }}
              </template>
            </el-table-column>
            <el-table-column label="承担方" prop="undertakeType" min-width="130px" align="center">
              <template v-slot="{ row }">
                <div>{{ dict.label.SOCIAL_INSURANCE_UNDERTAKE_TYPE[row.undertakeType] }}</div>
              </template>
            </el-table-column>
            <el-table-column label="缴纳方式" prop="calculateType" min-width="130px" align="center">
              <template v-slot="{ row }">
                <div>{{ dict.label.SOCIAL_INSURANCE_CALCULATE_TYPE[row.calculateType] }}</div>
              </template>
            </el-table-column>
            <el-table-column label="缴纳规则" min-width="250px" align="center">
              <template v-slot="{ row, $index }">
                <span v-if="row.calculateType == 'BY_BASE_RATE' || row.calculateType == 'BY_RATE_FIXED'">
                  基数：{{ row.lowerLimit | amountFormat }}
                  ~
                  {{ row.upperLimit | amountFormat }}
                </span>
                <span v-else="row.calculateType == 'BY_FIXED_AMOUNT'">按固定金额</span>
              </template>
            </el-table-column>
            <el-table-column label="企业缴纳" prop="entAmount" min-width="210px" align="center">
              <template v-slot="{ row, $index }">
                <template v-if="['ENT', 'ENT_PERSON'].includes(row.undertakeType)">
                  <div>{{row.entAmount | amountFormat}} 元</div>
                  <span  v-if="['BY_BASE_RATE', 'BY_RATE_FIXED'].includes(row.calculateType)">
                     (
                      <span>{{ row.lowerLimit | amountFormat }} x {{ row.entRate | amountFormat }}% </span>
                      <span v-if="row.calculateType == 'BY_RATE_FIXED'"> + {{row.entFixAmt | amountFormat}}</span>
                    )
                  </span>
                </template>
                <span v-else>/</span>
              </template>
            </el-table-column>
            <el-table-column label="个人缴纳" prop="personAmount" min-width="210px" align="center">
              <template v-slot="{ row, $index }">
                <template v-if="['PERSON', 'ENT_PERSON'].includes(row.undertakeType)">
                  <div>{{row.personAmount | amountFormat}} 元</div>
                  <span v-if="['BY_BASE_RATE', 'BY_RATE_FIXED'].includes(row.calculateType)">
                      (
                      <span>{{ row.lowerLimit | amountFormat }} x {{ row.personRate | amountFormat }}% </span>
                      <span v-if="row.calculateType == 'BY_RATE_FIXED'"> + {{row.personFixAmt | amountFormat}}</span>
                    )
                  </span>
                </template>
                <span v-else>/</span>
              </template>
            </el-table-column>
            <el-table-column label="增减员规则" min-width="120px" align="center">
              <template v-slot="{ row }">
                <div style="display: flex; flex-direction: column; gap: 5px;">
                  <div>
                    {{ row.addRule === 'ADD_CURRENT_MONTH' ? '增当月' : '增次月' }}
                    ，
                    {{ row.reduceRule === 'REDUCE_CURRENT_MONTH' ? '减当月' : '减次月' }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="缴费频率" min-width="90px" align="center">
              <template v-slot="{ row }">
                {{ row.payFrequency === 'MONTH' ? '月缴' : '年缴' }}
              </template>
            </el-table-column>
            <el-table-column label="加收当月" min-width="80px" align="center">
              <template v-slot="{ row }">
                <span v-if="row.payCurrentMonth === '1'">是</span>
                <span v-else style="color: red;">否</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      <el-divider content-position="left">公积金</el-divider>
      <div>
        <el-form-item :label="dict.label.WELFARE_TYPE[form.reserveFund.welfareType]"
          label-width="80px"></el-form-item>
        <el-form-item prop="reserveFund.lowerLimit" label="基数：" label-width="80px">
          {{form.reserveFund.lowerLimit |amountFormat}}
          ~ {{form.reserveFund.upperLimit |amountFormat}}
        </el-form-item>
        <el-form-item prop="reserveFund.entRate" label="企业缴纳：" label-width="120px">
          {{form.reserveFund.entAmount |amountFormat}}元
          ({{form.reserveFund.lowerLimit |amountFormat}} x {{form.reserveFund.entRate |amountFormat}}%)
        </el-form-item>
        <el-form-item prop="reserveFund.personRate" label="个人缴纳：" label-width="120px">
          {{form.reserveFund.personAmount |amountFormat}}元
          ({{form.reserveFund.lowerLimit |amountFormat}} x {{form.reserveFund.personRate |amountFormat}}%)
        </el-form-item>
        <el-form-item label="增减员规则：" label-width="120px">
          <div style="display: flex; gap: 20px; align-items: center;">
            <div>
              {{ form.reserveFund.addRule === 'ADD_CURRENT_MONTH' ? '增当月' : '增次月' }}，
              {{ form.reserveFund.reduceRule === 'REDUCE_CURRENT_MONTH' ? '减当月' : '减次月' }}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="缴费频率：" label-width="120px">
          {{ form.reserveFund.payFrequency === 'MONTH' ? '月缴' : '年缴' }}
        </el-form-item>
        <el-form-item label="加收当月：" label-width="120px">
          {{ form.reserveFund.payCurrentMonth === '1' ? '是' : '否' }}
        </el-form-item>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
import socialInsurancePolicyApi from '@/api/employee/socailInsurancePolicy'
import Area from '@/components/Area'
import areaData from '@/assets/json/area.json'
import { deepClone } from '@/utils'

const defaultForm = {
  cityCodes: [],
  areaPolicy: null,
  welfareList: [],
  cityCode: null,
  cityName: null,
  decimalPlace: '2',
  policySourceLinks: [],
  reserveFund: {
    classify: 'W02',
    entRate: null,
    lowerLimit: null,
    personRate: null,
    upperLimit: null,
    welfareType: 'RESERVE_FUND',
    addRule: 'ADD_CURRENT_MONTH',
    reduceRule: 'REDUCE_CURRENT_MONTH',
    payFrequency: 'MONTH',
    payCurrentMonth: false
  }
}
const defaultAddForm = {
  calculateType: null,
  classify: 'W01',
  entRate: null,
  entFixAmt: null,
  lowerLimit: null,
  personRate: null,
  personFixAmt: null,
  undertakeType: null,
  upperLimit: null,
  welfareType: null,
  addRule: 'ADD_CURRENT_MONTH',
  reduceRule: 'REDUCE_CURRENT_MONTH',
  payFrequency: 'MONTH',
  payCurrentMonth: false
}
const preWalfareList = [
  {
    welfareType: 'ENDOWMENT',
    undertakeType: 'ENT_PERSON',
    calculateType: 'BY_BASE_RATE',
    addRule: 'ADD_CURRENT_MONTH',
    reduceRule: 'REDUCE_CURRENT_MONTH',
    payFrequency: 'MONTH',
    payCurrentMonth: false
  },
  {
    welfareType: 'MEDICAL',
    undertakeType: 'ENT_PERSON',
    calculateType: 'BY_BASE_RATE',
    addRule: 'ADD_CURRENT_MONTH',
    reduceRule: 'REDUCE_CURRENT_MONTH',
    payFrequency: 'MONTH',
    payCurrentMonth: false
  },
  {
    welfareType: 'UNEMPLOYMENT',
    undertakeType: 'ENT_PERSON',
    calculateType: 'BY_BASE_RATE',
    addRule: 'ADD_CURRENT_MONTH',
    reduceRule: 'REDUCE_CURRENT_MONTH',
    payFrequency: 'MONTH',
    payCurrentMonth: false
  },
  {
    welfareType: 'EMPLOYMENT_INJURY',
    undertakeType: 'ENT',
    calculateType: 'BY_BASE_RATE',
    addRule: 'ADD_CURRENT_MONTH',
    reduceRule: 'REDUCE_CURRENT_MONTH',
    payFrequency: 'MONTH',
    payCurrentMonth: false
  },
  // {
  //   welfareType: 'MATERNITY',
  //   undertakeType: 'ENT',
  //   calculateType: 'BY_BASE_RATE',
  // },
]
export default {
  components: { Area },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.form = deepClone(defaultForm)
        if (this.id) {
          this.getData()
        }
        else {
          preWalfareList.forEach(item => {
            this.form.welfareList.push({ ...deepClone(defaultAddForm), ...item })
          })
        }
      }
      this.dialogVisible = val
    }
  },
  dicts: ['WELFARE_TYPE', 'SOCIAL_INSURANCE_UNDERTAKE_TYPE', 'SOCIAL_INSURANCE_CALCULATE_TYPE' ,'DECIMAL_PLACE'],
  data() {
    return {
      dialogVisible: this.visible,
      form: deepClone(defaultForm),
      publishRecords: []
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    // 通过cityCode找到省市信息
    findCity(cityCode) {
      for (let province of areaData) {
        if (province.children && province.children.length) {
          for (let city of province.children) {
            if (city.value == cityCode) {
              return {
                provinceName: province.label,
                provinceCode: province.value,
                cityName: city.label,
                cityCode: city.value
              }
            }
          }
        }
      }
      return null
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      return 'cell-class'
    },
    // 表格合计行：仅统计企业缴纳、个人缴纳合计金额
    getSummaries({ columns, data }) {
      const amountFormat = this.$options.filters.amountFormat
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
        } else if (column.property === 'entAmount') {
          const total = data.reduce((sum, row) => sum + (Number(row.entAmount) || 0), 0)
          sums[index] = amountFormat(total) + ' 元'
        } else if (column.property === 'personAmount') {
          const total = data.reduce((sum, row) => sum + (Number(row.personAmount) || 0), 0)
          sums[index] = amountFormat(total) + ' 元'
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
     async getData() {
      let data ={}
      if(this.type === 'detail'){
        data = await this.getDetail();
      }else{
        data = await this.getPublishedDetail();
      }
      this.form = data
      const cityCodes = this.findCity(this.form.cityCode)
      this.form.cityCodes = [cityCodes.provinceCode, cityCodes.cityCode]
      const welfareList = this.form.welfareList
      this.form.welfareList = welfareList.filter(item => item.classify == 'W01')
      this.form.reserveFund = welfareList.filter(item => item.classify == 'W02')[0]
      let policySourceLinks = []
      if (this.form.policyInfo) {
        policySourceLinks = JSON.parse(this.form.policyInfo)
      }
      this.$set(this.form, 'policySourceLinks', policySourceLinks)
    },
     getDetail() {
       return socialInsurancePolicyApi.getDetail(this.id)
    },
    getPublishedDetail(){
      return socialInsurancePolicyApi.getPublishedDetail(this.id)
    }
  },
}
</script>
<style lang="scss" scoped>
/deep/.el-table__cell {
  padding: 0;

  .cell {
    padding: 5px;
  }

  .el-form-item {
    padding: 0 !important;
    margin: 0 !important;
  }
}

/deep/.welfare-list-item {
  padding: 0 !important;
  margin: 0 !important;
  width: 100%;
  .el-form-item__content {
    width: 100% !important;
  }
}

.policy-section {
  margin-left: 20px;
  margin-bottom: 15px;
}

.policy-link-item {
  margin-bottom: 10px;
}

.social-row {
  padding: 10px 0;

  .social-row-title {}

  .social-row-item {}
}

.publish-records {
  margin-left: 20px;
  margin-bottom: 15px;
}
</style>
